import { render, staticRenderFns } from "./web.vue?vue&type=template&id=1a5af05c&scoped=true"
import script from "./web.vue?vue&type=script&lang=js"
export * from "./web.vue?vue&type=script&lang=js"
import style0 from "./web.vue?vue&type=style&index=0&id=1a5af05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5af05c",
  null
  
)

export default component.exports